import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoIsotipo } from '../components/Logo';

export default function Intro() {
    const navigate = useNavigate();
    const [code, setCode] = useState('');

    const onJoin = () => {
        const clean = code.trim().toUpperCase();
        if (!clean) return;
        navigate(`/unirte/${encodeURIComponent(clean)}`);
    };

    return (
        <div
            className="fixed inset-0 flex flex-col text-white overflow-y-auto"
            style={{
                background: 'linear-gradient(180deg, #5B5FDB 0%, #4346A3 100%)',
            }}
            data-testid="intro-screen"
        >
            <div className="flex-1 flex flex-col items-center justify-center px-8 py-12 max-w-md mx-auto w-full">
                <div className="flex flex-col items-center fade-up">
                    <LogoIsotipo size={180} className="mb-6 drop-shadow-xl" />
                    <p className="text-center text-lg text-white/95 leading-snug mb-10 max-w-xs">
                        Te damos la bienvenida a tu nuevo centro de coordinación familiar!
                    </p>
                </div>

                <div className="w-full space-y-3 fade-up fade-up-delay-1">
                    <button
                        onClick={() => navigate('/registro')}
                        className="w-full h-14 bg-white text-brand-navy rounded-full font-bold text-base shadow-lg hover:scale-[1.01] active:scale-[0.98] transition"
                        data-testid="intro-register-btn"
                    >
                        Regístrate
                    </button>
                    <button
                        onClick={() => navigate('/login')}
                        className="w-full h-14 bg-transparent border-2 border-white/60 text-white rounded-full font-bold text-base hover:bg-white/10 active:scale-[0.98] transition"
                        data-testid="intro-login-btn"
                    >
                        Iniciar Sesión
                    </button>
                </div>

                <div className="w-full mt-10 fade-up fade-up-delay-2">
                    <div className="flex items-center gap-3 mb-3">
                        <div className="flex-1 h-px bg-white/30" />
                        <span className="text-xs text-white/80 font-medium">¿Ya tienes un código de familia?</span>
                        <div className="flex-1 h-px bg-white/30" />
                    </div>
                    <div className="flex gap-2">
                        <input
                            type="text"
                            value={code}
                            onChange={(e) => setCode(e.target.value.toUpperCase())}
                            placeholder="FAM-XXXX-XXXX"
                            className="flex-1 h-12 bg-white/15 border border-white/40 rounded-full px-5 text-white placeholder:text-white/50 text-center tracking-wider focus:bg-white/20 focus:border-white/70"
                            data-testid="intro-family-code-input"
                        />
                        <button
                            onClick={onJoin}
                            disabled={!code.trim()}
                            className="px-6 h-12 bg-white text-brand rounded-full font-bold text-sm hover:scale-[1.02] active:scale-[0.97] transition disabled:opacity-50"
                            data-testid="intro-join-btn"
                        >
                            ¡Únete!
                        </button>
                    </div>
                </div>
            </div>

            <div className="text-center pb-8 text-xs text-white/60 font-medium">
                2026 — 4everSync v1.0.1
            </div>
        </div>
    );
}
